import { MutationTree } from 'vuex';
import { NoResultsState } from '../../models';
import { SetFallbackFiltersResultsMutation } from './mutations/set-fallback-filters-results.mutation';

export const NO_RESULTS_MUTATIONS: MutationTree<NoResultsState> = {
  ...new SetFallbackFiltersResultsMutation().mutations
};
